var AutocompleteComponent = Vue.component('auto-complete', {
    props: {
        data: {
            type: Object,
            required: false,
            default: function() {
                return {
                    remote: false,
                    url: '/',
                    matches: []
                };
            }
        },
        input: {
            type: Object,
            required: false,
            default: function() {
                return {
                    limit: 3,
                    placeholder: 'Search'
                };
            }
        },
        models: {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        time: {
            type: Number,
            required: false,
            default: function() {
                return 0;
            }
        }
    },
    template: `
        <div>
            <form method="get" accept-charset="utf-8" name="header_search" :action="data.remote ? data.url : '/'">
                <input
                    type="text"
                    :id="id"
                    @keydown.40="moveDown"
                    @keydown.38="moveUp"
                    @keyup.enter="redirectToSearch"
                    @focus="showMatches"
                    v-model="keyword"
                    name="search"
                    :placeholder="input.placeholder"
                    :class="input.class"
                    @input="search"
                />
            </form>

            <ul class= "ui-autocomplete ui-front ui-menu ui-widget ui-widget-content autocomplete vue-autocomplete" v-if="isOpen">
                <li v-if="hasCategories">
                    <ul>
                        <li class="autocomplete--heading ui-menu-item">
                            <h3>Nájdené kategórie</h3>
                        </li>

                        <li
                            v-for="(category, index) in categories"
                            :class="{
                                'autocomplete--categories': true,
                                'ui-menu-item': true,
                                'highlighted': category.index == highlightedPosition
                            }"
                            @mouseenter="highlightedPosition = category.index"
                        >
                            <i class="fas fa-angle-right"></i>
                            <a
                                :href="category.link"
                                :title="category.name"
                                :data-id="category.id"
                                v-html="highlight(category.name, keyword)">
                            </a>
                        </li>
                    </ul>
                </li>

                <li v-if="hasProducts">
                    <ul>
                        <li class="autocomplete--heading ui-menu-item">
                            <h3>Nájdené produkty</h3>
                        </li>

                        <li
                            v-for="(product, index) in products"
                            :class="{
                                'autocomplete--products': true,
                                'ui-menu-item': true,
                                'highlighted': product.index == highlightedPosition
                            }"
                            @mouseenter="highlightedPosition = product.index"
                        >
                            <a
                                :href="product.link"
                                v-on:click="onProductClick($event, product)"
                                :title="product.name"
                                :data-id="product.id"
                            >
                                <div class="autocomplete__img">
                                    <img :src="product.image" :alt="product.name" />
                                </div>

                                <div class="autocomplete__info">
                                    <div class="autocomplete__name" v-html="highlight(product.name, keyword)"></div>
                                    <div class="autocomplete__price">
                                        {{ formatPrice(product.price) }}<span> s DPH</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    `,
    data: function () {
        return {
            isOpen: false,
            highlightedPosition: 0,
            keyword: new URL(window.location.href).searchParams.get('search'),
            matches: [],
            id: 'autocomplete-' + parseInt(Math.random() * 1000),
            timeout: null,
            activeTabIndex: 0,
            categoryId: null,
            request: null,
            selectedProductIndex: -1,
            isInputFocused: false
        }
    },
    mounted: function() {
        var _self = this;

        document.addEventListener('click', _self.handleClickOutside);
    },
    created: function() {
    },
    destroyed: function () {
        document.destroyed('click', this.handleClickOutside);
    },
    methods: {
        search: function() {
            var _self = this;

            if (_self.timeout) {
                clearTimeout(_self.timeout);
            }

            if (_self.input.limit > _self.keyword.length + 1) {
                return false;
            }

            if (!_self.data.remote) {
                return _self.setMatches(_self.data.matches.filter(item => item.name.toLowerCase().indexOf(_self.keyword.toLowerCase()) > -1));
            }

            if (_self.request) {
                _self.request.abort();
            }

            this.timeout = setTimeout(function() {
                _self.request = _self.fetch('get', _self.data.url, {
                    limit: _self.input.limit,
                    search: _self.keyword,
                    category_id: _self.categoryId,
                    get: _self.data.getModels ? _self.data.getModels : [],
                    group: window.Eshop.options.customer_group_id ? window.Eshop.options.customer_group_id : null,
                    customer_id: window.Eshop.options.customer_id ? window.Eshop.options.customer_id : null,
                }, function (response) {
                    _self.setMatches(response);
                });
            }, _self.time);
        },
        setMatches(matches) {
            var _self = this;

            _self.matches = _.map(_.filter(matches, function (item) {
                return item.type != 'heading' && item.type != 'noresults';
            }), function (item, key) {
                item.index = key;

                if (item.table_name == 'Products') {
                    _self.$store.commit('addProductData', item);
                }

                return item;
            });

            _self.showMatches();

            return true;
        },
        showMatches: function() {
            if (this.keyword == '' || this.isOpen) {
                return;
            }

            this.isOpen = true;
            this.selectedProductIndex = -1;

            rEvent.dispatch('Autocomplete.show');
        },
        highlight: function (text, search) {
            $("body").append("<span id=\"highlightText\" style=\"display:none;\">" + text + "</span>");

            var $highlight = $("#highlightText"),
                instance = new Mark("span#highlightText");

            instance.mark(search, { className: "", exclude: ["img *"] });
            text = $highlight.html();
            $highlight.remove();

            return text;
        },
        moveDown() {
            if (!this.isOpen || !this.has('Products')) {
                return false;
            }

            if (this.selectedProductIndex < this.get('Products').length - 1) {
                this.selectedProductIndex++;
            }
        },
        moveUp() {
            if (!this.isOpen || !this.has('Products')) {
                this.selectedProductIndex = -1;

                return false;
            }

            if (this.selectedProductIndex !== -1) {
                this.selectedProductIndex--;
            }
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target) && this.isOpen) {
                this.isOpen = false;
                this.selectedProductIndex = -1;

                rEvent.dispatch('Autocomplete.hide');
            }
        },
        onProductClick($event, product) {
            return true;
        },
        has: function(model) {
            return this.get(model).length > 0;
        },
        get: function(model) {
            return _.filter(this.matches, function (item) {
                return item.table_name == model;
            });
        },
        getModelCount: function(model) {
            return this.totals.models[model]
        },
        isActiveTab(item) {
            return item == this.activeTab;
        },
        showTab(item) {
            this.activeTabIndex = this.navItems.indexOf(item);
        },
        redirectToUrl(url) {
            window.location.href = url;
        },
        inputFocused() {
            this.isInputFocused = true;
        },
        inputBlurred() {
            this.selectedProductIndex = -1;
            this.isInputFocused = false;
        },
        redirectToSearch() {
            window.location.href = this.searchUrl
        }
    },
    computed: {
        hasMatches: function () {
            return this.matchesCount > 0;
        },
        pricesWithVat: function() {
            return Eshop.options.pricesWithVat;
        },
        totals: function() {
            var totals = _.filter(this.matches, function (item) {
                return item.type == 'totals';
            });

            return totals[0];
        },
        matchesCount: function() {
            return this.totals.count;
        },
        showNav: function() {
            return this.hasMatches && this.navItems.length > 1;
        },
        navItems: function() {
            var items = this.matches.filter(function(item) {
                return typeof item.table_name !== 'undefined';
            }),
                navItems = _.map(items, function(item) {
                    return item.table_name + (item.type ? ';' + item.type : '');
                });

            return _.uniq(navItems);
        },
        activeTab: function() {
            var activeTabIndex = typeof this.navItems[this.activeTabIndex] !== 'undefined' ? this.activeTabIndex : 0;

            return this.navItems.length > 0 ? this.navItems[activeTabIndex] : null;
        },
        selectedProduct: function() {
            if (this.selectedProductIndex === -1) {
                return false;
            }

            return this.get('Products')[this.selectedProductIndex];
        },
        searchUrl() {
            return `/vyhladavanie${this.keyword ? `?search=${this.keyword}` : ''}`
        }
    }
});
